import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {getProductById} from "../../../redux/actions/product";

import {Grid, Row, Col, Alert} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

class ProductDetail extends React.Component {

    constructor(props) {
        super(props);

        const id = props.match.params.id;

        props.getProductById(id);
        this.state = {
            pContainer1: false,
            pContainer2: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.props.getProductById(this.props.match.params.id);
        }
    }

    render() {
        const {product, loading} = this.props;
        const pContainer1 = this.state.pContainer1;
        const pContainer2 = this.state.pContainer2;

        // Affichage pendant le chargement
        if (loading) {
            return (
                <div className="main-content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    title="Chargement..."
                                    content={
                                        <div style={{textAlign: 'center', padding: '40px'}}>
                                            <i className="fa fa-spinner fa-spin" style={{fontSize: '24px'}}></i>
                                            <p style={{marginTop: '16px'}}>Chargement des détails du produit...</p>
                                        </div>
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
            );
        }

        // Affichage si le produit n'est pas trouvé
        if (!product) {
            return (
                <div className="main-content">
                    <Grid fluid>
                        <Row>
                            <Col md={12} style={{marginBottom: "16px"}}>
                                <Link to="/app/product/list">
                                    <Button bsStyle="default" fill bsSize="lg">Retour</Button>
                                </Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Alert bsStyle="warning">
                                    <h4><i className="fa fa-exclamation-triangle"></i> Produit non trouvé</h4>
                                    <p>Le produit demandé n'a pas pu être trouvé. Il est possible qu'il ait été supprimé ou que l'ID soit incorrect.</p>
                                    <p>ID recherché: {this.props.match.params.id}</p>
                                    <Link to="/app/product/list">
                                        <Button bsStyle="primary">Retourner à la liste des produits</Button>
                                    </Link>
                                </Alert>
                            </Col>
                        </Row>
                    </Grid>
                </div>
            );
        }

        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={12} style={{marginBottom: "16px"}}>
                            <Link to="/app/product/list">
                                <Button bsStyle="default" fill bsSize="lg">Retour</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Card
                                title={product.nom || 'Produit sans nom'}
                                content={
                                    <div>
                                        <p><strong>Substance active / DCI:</strong> {product.DCI || 'Non spécifié'}</p>
                                        <p><strong>Dosage:</strong> {product.dosage || 'Non spécifié'}</p>
                                        <p><strong>Forme:</strong> {product.forme || 'Non spécifié'}</p>
                                        <p><strong>Conditionnement:</strong> {product.conditionnement || 'Non spécifié'}</p>
                                        <p><strong>Excipients à effets notoires:</strong> {product.excipientEffetsNotoires || 'Non spécifié'}</p>
                                        <p><strong>Famille thérapeutique:</strong> {product.familleTherapeutique || 'Non spécifié'}</p>
                                        <p><strong>Classe pharmacologique:</strong> {product.classesPharmacologiques || 'Non spécifié'}</p>
                                        <p><strong>Maladie traitée:</strong> {product.maladieTraitee || 'Non spécifié'}</p>
                                        <p><strong>Code ATC:</strong> {product.codeATC || 'Non spécifié'}</p>
                                        <p>
                                            <strong>Liste:</strong>{' '}
                                            <span style={{
                                                color: product.liste && (product.liste.toLowerCase().includes('liste i') || product.liste.toLowerCase().includes('stupéfiant'))
                                                    ? 'red'
                                                    : product.liste && product.liste.toLowerCase().includes('liste ii')
                                                    ? 'green'
                                                    : 'inherit',
                                                fontWeight: (product.liste && (product.liste.toLowerCase().includes('liste i') || product.liste.toLowerCase().includes('liste ii') || product.liste.toLowerCase().includes('stupéfiant'))) ? 'bold' : 'normal'
                                            }}>
                                                {product.liste || 'Non spécifié'}
                                            </span>
                                        </p>
                                        <p><strong>Assurance:</strong> {product.assurance || 'Non spécifié'}</p>
                                        <p><strong>Fabricant:</strong> {product.fabricant || 'Non spécifié'}</p>
                                        <p><strong>No AMM ou enregistrement:</strong> {product.nomAMMouEnregistrement || 'Non spécifié'}</p>

                                        {product.isRef ? (
                                            <div>
                                                 <Button style={{color: 'black', backgroundColor: 'white', border: 'white'} }
                                                    onClick={()=>this.setState({pContainer1:!this.state.pContainer1})}>
                                                    {pContainer1?<p><strong>Propriétés <i className="fa fa-chevron-up"/></strong></p>:<p><strong>Propriétés <i className="fa fa-chevron-down"/></strong></p>}
                                                 </Button>
                                                {pContainer1 && product.proprietes && (<p>{product.proprietes}</p>)}

                                                <p><strong>Indications:</strong> {product.indications || 'Non spécifié'}</p>
                                                <p><strong>Posologie:</strong> {product.posologie || 'Non spécifié'}</p>
                                                <p><strong>Contre-indications:</strong> {product.contreIndications || 'Non spécifié'}</p>
                                                <Button style={{color: 'black', backgroundColor: 'white', border: 'white'}}
                                                    onClick={()=>this.setState({pContainer2:!this.state.pContainer2})}>
                                                    {pContainer2?<p><strong>Effets indésirables <i className="fa fa-chevron-up"/></strong></p>:<p><strong>Effets indésirables <i className="fa fa-chevron-down"/></strong> </p>}
                                                 </Button>
                                                {pContainer2 && product.effetsIndesirables && (<p>{product.effetsIndesirables}</p>)}


                                                <p><strong>{'Précautions d\'emploi:'}</strong> {product.precautionsEmploi || 'Non spécifié'}</p>
                                                <p><strong>Interactions médicamenteuses:</strong> {product.interactionsMedicamenteuses || 'Non spécifié'}</p>
                                                <p><strong>Références:</strong> {product.references || 'Non spécifié'}</p>
                                            </div>
                                        ) : (
                                            <Alert bsStyle="info">
                                                <span>
                                                    {"Ce produit n'est pas un produit référence. Pour voir toutes les propriétés de ce produit "}
                                                    {product.referenceProductId && (
                                                        <Link
                                                            to={`/app/product/detail/${product.referenceProductId}`}
                                                            style={{color: "#FFFFFF", fontSize: "17px"}}
                                                        >
                                                            <strong>cliquer ici</strong>
                                                        </Link>
                                                    )}
                                                    {!product.referenceProductId && (
                                                        <span>contactez l'administrateur</span>
                                                    )}
                                                    .
                                                </span>
                                            </Alert>
                                        )}
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        product: state.products.product,
        loading: state.status.loading
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getProductById: id => {
            dispatch(getProductById(id));
        }
    }
};

ProductDetail.propTypes = {
    match: PropTypes.object,
    product: PropTypes.object,
    getProductById: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
